import { createContext, useCallback, useContext, useMemo } from 'react';
import { keys, noop } from 'lodash';
import { isEmpty } from 'lodash';
import { ModuleContext } from '../../module/ModuleProvider';
import { APP_EVENT_TYPE } from '../appEventType';

export const AppEventsContext = createContext({ register: noop, push: noop });

const transformData = (event, toGWTransformers, pathToEntity) => {
    const { type: eventType, data } = event || {};
    if (eventType === APP_EVENT_TYPE.CHAT_DIALOG_MESSAGE) {
        return data;
    }

    if (isEmpty(toGWTransformers) || isEmpty(pathToEntity) || isEmpty(data)) {
        return data;
    }

    return keys(data).reduce((acc, key) => {
        const entity = pathToEntity[key];
        if (entity) {
            const transformer = toGWTransformers[entity];
            if (transformer) {
                const transformedData = transformer(data[key]);
                acc[key] = transformedData;
            }
        }
        return acc;
    }, {});
};

export const useAppEventContext = () => {
    const { push, ...rest } = useContext(AppEventsContext);
    const { toGWTransformers, pathToEntity } = useContext(ModuleContext);
    const pushWrapper = useCallback(
        event => {
            const transformedData = transformData(event, toGWTransformers, pathToEntity);

            return push({
                ...event,
                data: {
                    ...event.data,
                    ...transformedData,
                },
            });
        },
        [pathToEntity, push, toGWTransformers]
    );
    const wrappedValue = useMemo(() => ({ push: pushWrapper, ...rest }), [pushWrapper, rest]);

    return wrappedValue;
};
